import {
  TAddressDetails,
  TContactDetails,
  TPrimaryDetails,
  TUserDetails,
} from '../users/users.interfaces';
import { TUserAction, TPaginationParams, TPaginatedResponse } from '../__shared/shared.interfaces';

export enum EMPLOYMENT_STATUS {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  ON_LEAVE = 'on_leave',
  RETIRED = 'retired',
}

export type TStaffListApiResponse = TPaginatedResponse<TStaffResponse>;

export interface TStaffListParams extends TPaginationParams {
  search?: string;
  department?: string;
  designation?: string;
  employmentStatus?: EMPLOYMENT_STATUS | string;
  instituteId?: string;
}

export type TStaffResponse = TUserDetails & {
  designation: string;
  department: string;
  joiningDate: TUserAction;
  employmentStatus: EMPLOYMENT_STATUS | 'select';
  /** Flattened email for grid display convenience */
  email?: string;
};

export type TStaffDetailsResponse = {
  id: string;
  documents: string[];
  designation: string;
  department: string;
  joiningDate: string;
  employmentStatus: EMPLOYMENT_STATUS | 'select';
  basicDetails: TPrimaryDetails;
  addressDetails: TAddressDetails;
  contactDetails: TContactDetails;
  /** TODO: Naman - Add previousExperience to staff profile API */
  previousExperience?: TPreviousExperience[];
  createdBy: string;
  createdAt: string;
};

export type TStaffPrimary = TUserDetails & {
  designation: string;
  joiningDate: Date;
  department: string;
};

export type TStaffApiResponse = TPaginatedResponse<TStaffPrimary>;

export type TStaffCreationPayload = {
  userId: string;
  instituteId: string;
  supervisorId: string;
  documents: string[];
  designation: string;
  department: string;
  joiningDate: string;
  employmentStatus: string;
  addressId: string;
  contactId: string;
  createdBy: string;
};

export type TStaffUpdatePayload = {
  designation?: string;
  department?: string;
  joiningDate?: string;
  employmentStatus?: string;
  documents?: string[];
  updatedBy?: string;
};

// ---------------- Staff Details Endpoint Interfaces -----------------
export interface TStaffDetails {
  basic_details: TStaffBasicDetails;
  user?: TStaffUser;
  institute: TStaffInstitute;
  address?: TStaffAddress;
  contact?: TStaffContact;
  action: TStaffUserAction;
}

export interface TStaffBasicDetails {
  _id: string;
  designation: string;
  joining_date: Date;
  department: string;
  employment_status?: string; // StaffStatus enum
  documents: string[]; // Array of document IDs
  /** TODO: Naman - Add previousExperience to staff profile API */
  previous_experience?: TPreviousExperience[];
}

export interface TStaffUser {
  _id?: string;
  first_name?: string;
  last_name?: string;
  gender?: string; // 'male' | 'female' | 'trans'
  user_role?: string; // UserRoles enum
  email?: string;
  phone?: string;
}

export interface TStaffInstitute {
  _id: string;
  name: string;
}

export interface TStaffAddress {
  _id?: string;
  city?: string;
  state?: string;
  country?: string;
  pincode?: string;
  address_line_1?: string;
  address_line_2?: string;
}

export interface TStaffContact {
  _id?: string;
  email?: string;
  country_code?: string;
  phone_number?: string;
  is_phone_verified?: boolean;
  is_email_verified?: boolean;
}

export interface TStaffUserAction {
  created_at: Date;
  created_by: string;
  updated_at: Date;
  updated_by: string;
}

/** Previous work experience. TODO: Naman - Add previousExperience to staff profile API */
export interface TPreviousExperience {
  company: string;
  role: string;
  from: string; // ISO date
  to: string; // ISO date
  description?: string;
}
